import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { InsuranceTypeSelect } from '@components/InsuranceTypeSelect/InsuranceTypeSelect'
import { NearestTimeslots } from '@components/NearestTimeslots/NearestTimeslots'
import { PatientTypeSelect } from '@components/PatientTypeSelect/PatientTypeSelect'
import { Button } from '@components/Button/Button'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { OldPatientPhoneInput } from '@screens/OldPatientIdentification/OldPatientPhoneInput/OldPatientPhoneInput'
import { usePhoneInput } from '@screens/OldPatientIdentification/OldPatientPhoneInput/usePhoneInput'
import { useHasUserSelectedSlot } from '@hooks/useHasUserSelectedSlot'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { completedInsurance, completedPatientType } from 'src/services/analytics'
import routes from 'src/config/routes'
import useStyles from './styles'

interface Props {
  phoneInput: ReturnType<typeof usePhoneInput>
  afterTimeslotSelect: () => void
}

export const Body = ({ phoneInput, afterTimeslotSelect }: Props) => {
  const classes = useStyles()
  const { patientType } = useChoiceState()
  const { isInternalClinic } = useConfig()
  const isNewPatient = patientType === PatientTypeOptions.NEW
  const { t } = useTranslation()
  const history = useHistory()
  const hasUserSelectedSlot = useHasUserSelectedSlot()

  const handleSeeTimeSlotsClicked = () => {
    if (!isInternalClinic) completedPatientType()
    completedInsurance()
    history.push(routes.appointment)
  }

  const internalClinicFlow = isNewPatient ? (
    <>
      <span className={classes.insuranceTypeQuestion}>{t('insurance_type_question')}</span>
      <InsuranceTypeSelect />
      <div className={classes.insuranceSelectBottom} />
      <NearestTimeslots afterTimeslotSelect={afterTimeslotSelect} />
    </>
  ) : (
    <OldPatientPhoneInput {...phoneInput} />
  )

  const externalClinicFlow = isNewPatient ? (
    <>
      <span className={classes.insuranceTypeQuestion}>{t('insurance_type_question')}</span>
      <InsuranceTypeSelect />
      <div className={classes.insuranceSelectBottom} />
      <NearestTimeslots afterTimeslotSelect={afterTimeslotSelect} />
    </>
  ) : (
    <>
      <span className={classes.insuranceTypeQuestion}>{t('insurance_type_question')}</span>
      <InsuranceTypeSelect />
      <div className={classes.insuranceSelectBottom} />
      {!hasUserSelectedSlot && (
        <Button
          className={classes.seeMoreSlotsButton}
          text={t('external_clinic_patient_page_see_time_slots')}
          onClick={handleSeeTimeSlotsClicked}
        />
      )}
    </>
  )

  return (
    <div className={classes.container}>
      <span className={classes.patientQuestion}>{t('patient_page_desktop_headline')}</span>
      <PatientTypeSelect />
      <div className={classes.patientSelectBottom} />
      {patientType ? (isInternalClinic ? internalClinicFlow : externalClinicFlow) : null}
    </div>
  )
}
